import Vue from 'vue'
import VueRouter from 'vue-router'
/* Layout */
import Layout from '@/layout'
// import Wave from '@/components/Wave'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Layout,
    meta: { title: '首页', icon: 'el-icon-set-up' },
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/Home'),
        meta: { title: '首页', icon: 'dashboard' },
        redirect: '/content',
        children: [
          {
            path: '/content',
            name: 'Content',
            component: () => import('@/views/Home/modules/ContentBox'),
            meta: { title: '首页-内容', icon: 'dashboard' },
            redirect: '/articleList',
            children: [
              {
                path: '/articleList',
                name: 'ArticleList',
                component: () => import('@/views/Home/modules/ContentBox/modles/ArticleList'),
                meta: { title: '首页-内容-文章列表', icon: 'dashboard' }
              },
              {
                path: '/doc',
                name: 'Doc',
                component: () => import('@/components/MarkdownView'),
                meta: { title: '首页-内容详情', icon: 'dashboard' }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/resume',
    name: 'Resume',
    component: () => import('@/views/Resume')
    // meta: { title: 'Test', icon: 'dashboard' }
    // redirect: '/home',
    // children: []
  },
  {
    path: '/code',
    name: 'Code',
    component: () => import('@/views/CodeRepos')
    // meta: { title: 'Test', icon: 'dashboard' }
    // redirect: '/home',
    // children: []
  },
  {
    path: '/communication',
    name: 'Communication',
    component: () => import('@/views/Communication')
    // meta: { title: 'Test', icon: 'dashboard' }
    // redirect: '/home',
    // children: []
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/Test')
    // meta: { title: 'Test', icon: 'dashboard' }
    // redirect: '/home',
    // children: []
  },
  // G:\00-Workspace\LIMIT-YANG-EDGE\edge-c-dev\src\views\Test\test2.vue
  {
    path: '/test2',
    name: 'Test2',
    component: () => import('@/views/Test/test2')
    // meta: { title: 'Test', icon: 'dashboard' }
    // redirect: '/home',
    // children: []
  }
]

const router = new VueRouter({
  routes
})

export default router
